import React from 'react';
import githubIcon from '../images/icons/github_icon.svg';
import instagramIcon from '../images/icons/instagram_icon.svg';
import linkedinIcon from '../images/icons/linkedin_icon.svg';
import locationIcon from '../images/icons/location_icon.svg';
import mailIcon from '../images/icons/mail_icon.svg';
import { trackEvent } from '../utils/analytics';
import AbstractSymbolRow from './AbstractSymbolRow';
import TrackedLink from './TrackedLink';

function Footer() {
    return (
        <footer id="footer" className="container-fluid justify-content-center" aria-label="Footer">
            <AbstractSymbolRow variant="footer" className="abstract-float" />
            <div className="row align-items-center justify-content-center footer bg-accent-purple">
                <a
                    href="#footer-end"
                    className="skip-link footer-skip-link color-tan-hover"
                    aria-label="Skip Footer Links"
                >
                    Skip Footer Links
                </a>
                <div className="row align-items-center text-color-light">
                    <img className="icon" src={locationIcon} alt="location pin icon" />
                    <p>Philadelphia, PA</p>
                </div>
                <a
                    className="row align-items-center text-color-light footer-link hover-sweep"
                    href="mailto:olivia.knestaut@gmail.com"
                    aria-label="Email olivia.knestaut@gmail.com"
                    onClick={() => trackEvent('Contact', 'Clicked Email', 'Footer')}
                >
                    <img className="icon" src={mailIcon} alt="email icon" />
                    <span>olivia.knestaut@gmail.com</span>
                </a>
                <TrackedLink
                    href="https://www.instagram.com/ollywhelmed/"
                    label="Instagram Footer"
                    aria-label="@ollywhelmed on Instagram — opens in a new tab"
                    className="row align-items-center text-color-light footer-link hover-sweep"
                >
                    <img className="icon" src={instagramIcon} alt="instagram icon" />
                    <span>@ollywhelmed</span>
                </TrackedLink>
                <TrackedLink
                    href="https://www.linkedin.com/in/oliviaknestaut/"
                    label="LinkedIn Footer"
                    aria-label="oliviaknestaut on LinkedIn — opens in a new tab"
                    className="row align-items-center text-color-light footer-link hover-sweep"
                >
                    <img className="icon" src={linkedinIcon} alt="linkedin icon" />
                    <span>oliviaknestaut</span>
                </TrackedLink>
                <TrackedLink
                    href="https://github.com/OliviaKnestaut"
                    label="GitHub Footer"
                    aria-label="OliviaKnestaut on GitHub — opens in a new tab"
                    className="row align-items-center text-color-light footer-link hover-sweep"
                >
                    <img className="icon" src={githubIcon} alt="github icon" />
                    <span>OliviaKnestaut</span>
                </TrackedLink>
                <span id="footer-end" className="sr-only" tabIndex="-1" aria-hidden="true">
                    End of footer
                </span>
            </div>
        </footer>
    );
}

export default Footer;
